import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let newLimit;
class TableRowItalicEdit extends Component {

    constructor(props) {
        super(props);
        this.state = { LimiteCompra: this.props.row.LimiteCompra, newLimit: true };
    }

    changeLimit(event) {
        this.props.modificacionNovedad(parseInt(event.target.value), this.props.novedad.Id, this.props.row.Id);
    }

    aceptarCambios() {
        this.props.aceptarEdicion();

    }

    cancel() {
        this.props.cancelEdicionNovedad(this.props.novedad.Id, this.props.row.Id);
    }

    leaveLimite() {
        this.props.desaparicionLapizEdicion();
    }

    editLimite() {
        this.props.comienzoDeEdicion(this.props.row.Id, this.props.novedad.ValorNovedad, this.props.novedad.ValorAnterior);
    }

    //viewEdit() {
    //    if (this !== null) {
    //        viewEdit(this.props.row.Id);
    //    }
    //    else {
    //        viewEditNoRow();
    //    }
    //}

    //viewEditClose() {
    //    viewEditClose();
    //}

    render() {
        let timeToNovedad = null;
        let drawName = null;
        let drawNovedad = null;
        let fecha = null;
        let hora = null;
        let name = this.props.row.Descripcion;
        let limiteCompra = this.props.row.LimiteCompra;

        if (this.props.novedad !== undefined) {
            let valorNovedad = this.props.novedad.ValorNovedad;
            let valorAnterior = this.props.novedad.ValorAnterior;

            if (this.props.novedadEditado != undefined) {
                if (this.props.novedadEditado.edited) {
                    limiteCompra = this.props.novedadEditado.ValorNovedad;
                }
                else {
                    limiteCompra = valorNovedad;
                }
            } else {
                limiteCompra = valorNovedad;
            }

            timeToNovedad = this.props.novedad.FechaHoraModificacion.replace("T", " ").replace("Z", "");
            fecha = timeToNovedad.substring(0, 10).split("-");
            hora = timeToNovedad.substring(16, 11);

            name = name + " (" + this.props.row.TipoDeEmpresa + "):"

            drawName = <div className="col-md-5">
                <label className="label-secondary">{name}</label>
            </div>

            //if (this.props.editadoRow == true) {
            //    valorAnterior = GlobalHelper.ConvertirNumeroMilesMillones(valorAnterior);
            //    drawNovedad = <div className="row">
            //        <div className="col-md-6">
            //        </div>
            //        <div className="col-md-6">
            //            <p ><sub><i>Editado el {fecha[2] + "-" + fecha[1]} a las {hora} por {this.props.novedad.UsuarioLoginModificacion}. Era ${valorAnterior}.</i></sub><a className="clickable" onClick={this.viewEditClose}><sub><ins><i>Cerrar</i></ins></sub></a></p>
            //        </div>
            //    </div>
            //}
            //else {
            //    drawNovedad = <div className="row">
            //        <div className="col-md-6">
            //        </div>
            //        <div className="col-md-6">
            //            <a className="clickable" onClick={this.viewEdit}><sub><ins><i>Editado</i></ins></sub></a>
            //        </div>
            //    </div>
            //}

        } else {
            name = name + " (Nueva):"

            drawName = <div className="col-md-5">
                <label className="label-secondary"><i>{name}</i></label>
            </div>
        }

        let draw = null;
        if (this.props.editRow == true) {
            draw = <div className="col-md-6">
                <div className="row">
                    <div className="col-md-1">
                        <label className="label-secondary"><i>$</i></label>
                    </div>
                    <div className="col-md-11 no-padding-left">
                        <div className="row">
                            <div className="col-md-4">
                                <input type="text" id={this.props.row.Id} value={limiteCompra} className="form-control default-input valid"
                                    onChange={this.changeLimit.bind(this)}></input>
                            </div>
                            <div className="col-md-3">
                                <GenericSimpleButton text="Listo" buttonClass="btn btn-cta" onClick={this.aceptarCambios.bind(this)} />
                            </div>
                            <div className="col-md-5">
                                <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={this.cancel.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        } else {
            limiteCompra = GlobalHelper.ConvertirNumeroMilesMillones(limiteCompra);

            draw = <div className="col-md-3" onMouseLeave={this.leaveLimite.bind(this)}>
                <div className="col-md-1 width-0">
                    <label className="label-secondary"><i>$</i></label>
                </div>
                <div className="col-md-4 no-padding-left">
                    <div className="container-distribution">
                        <label className="label-secondary hand color-azul-claro" onClick={this.editLimite.bind(this)} ><i>{limiteCompra}</i></label>
                        <span onClick={this.editLimite.bind(this)} className="ti-pencil hand" aria-hidden="true"></span>
                    </div>
                </div>
                <div className="col-md-7"></div>
            </div>
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-1">
                    </div>
                    {drawName}
                    {draw}
                </div>
                {drawNovedad}
            </div>

        );
    }

}

export default TableRowItalicEdit